<template>
  <div class="main-menu">
    <Menu :mode="mode" :active-name="activeMenu" @on-select="handleOnSelectMenuItem">
      <MenuItem name="company-explore">
        <Icon type="ios-search"></Icon>
        Explore
      </MenuItem>
      <MenuItem name="my-listing" v-if="loggedInUserType == 2">
        <Icon type="ios-list"></Icon>
        My Listing
      </MenuItem>
      <MenuItem name="dashboard" v-if="loggedInUserType == 2">
        <Icon type="ios-stats"></Icon>
        Dashboard
      </MenuItem>
      <MenuItem :name="(loggedInUserType == 2)? 'tech-rfp-list':'buyer-rfp-list'">
        <Icon type="ios-paper-outline"></Icon>
        RFP List
      </MenuItem>
      <MenuItem :name="(loggedInUserType == 2)? 'tech-rfps-messages':'buyer-rfps-messages'">
        <Icon type="ios-mail-outline"></Icon>
        <span v-if="loggedInUserType == 3">My</span>RFP Exchange
      </MenuItem>
      <MenuItem :name="(loggedInUserType == 2)? 'tech-bookmarks':'buyer-bookmarks'">
        <Icon type="ios-bookmark-outline"></Icon>
        Bookmarks
      </MenuItem>
      <MenuItem :name="(loggedInUserType == 2)? 'tech-account-settings':'buyer-account-settings'">
        <Icon type="ios-person-outline"></Icon>
        Account Settings
      </MenuItem>
      <MenuItem :name="(loggedInUserType == 2)? 'tech-support':'buyer-support'">
        <Icon type="ios-chatboxes-outline"></Icon>
        FAQ
      </MenuItem>
      <MenuItem name="logout">
        <Icon type="ios-lock-outline"></Icon>
        Logout
      </MenuItem>
    </Menu>
  </div>
</template>

<script>
import { logout } from '@/services/auth'

export default {
  props: {
    mode: {
      type: String,
      default: 'horizontal'
    }
  },

  data () {
    return {
      activeMenu: '',
      loggedInUserType: null,
      logType: localStorage.getItem('logType')
    }
  },
  watch: {
    '$route.name' (val) {
      this.handleActiveMenu(val)
    }
  },
  mounted () {
    this.handleActiveMenu(this.$route.name)
  },
  created () {
    this.activeMenu = this.$route.name
    if (localStorage.getItem('userType')) {
      this.loggedInUserType = localStorage.getItem('userType')
    } else {
      this.$router.push({
        name: 'buyer-login'
      })
    }
  },
  methods: {
    handleOnSelectMenuItem (val) {
      this.$emit('on-select')
      if (val === 'logout') {
        logout()
        window.location.pathname = '/'
      } else {
        this.$router.push({
          name: val
        })
      }
    },
    handleActiveMenu (val) {
      if (val === 'active-promotions') {
        this.activeMenu = 'dashboard'
      } else if (val === 'my-listing-form') {
        this.activeMenu = 'my-listing'
      } else {
        this.activeMenu = val
      }
    }
  }
}
</script>

<style scoped lang="scss">
.main-menu {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, .07);
  padding: 0 5em;
  background: #fff;
  border-bottom: 1px solid #dcdee2;
  .ivu-menu-horizontal.ivu-menu-light:after {
    display: none;
  }
}
</style>

<style lang="scss">
.main-menu {
  .ivu-menu-item {
    border-bottom: 2px solid transparent !important;

    &:hover {
      color: $primary !important;
      border-bottom: 2px solid $primary !important;
    }
    &.ivu-menu-item-active {
      color: $primary !important;
      border-bottom: 2px solid $primary !important;
    }
  }
}
</style>
